import React from 'react';
import '../../styles/RateCard.css';

const PubliNotes = () => {
    return (
        <section className="publi-notes-section py-5">
            <div className="container">
                <div className="row gx-5 align-items-center">

                    {/* Columna Izquierda */}
                    <div className="col-md-6 bg-dark-teal text-white p-5 rounded-start" data-aos="fade-right" data-aos-delay="200">
                        <h2 className="title text-white text-capitalize">
                            Publi <span className="highlight-bg">Notas</span> con Video*
                        </h2>
                        <p className="mt-4">
                            Diseñadas con un enfoque personalizado y narrativo, integran storytelling adaptado a tu identidad
                            para conectar de manera directa con la audiencia y garantizar un impacto inmediato.
                            Con contenido visual atractivo y alineado a los intereses de la comunidad, estas
                            notas se convierten en un puente ideal entre tu mensaje y los lectores.
                        </p>
                        <ul className="mt-4 custom-bullets">
                            <li>Contenido diseñado con storytelling que se alinea a los valores y objetivos de tu marca.</li>
                            <li>Incluye imágenes, gráficos, elementos visuales y cápsulas de video (opcional) que refuerzan el mensaje. (Logos y links).</li>
                            <li>Publicidad contextual y banners diseñados para complementar la publinota.</li>
                            <li>Replicada en BeHealth y canales de redes sociales, amplificando el alcance.</li>
                        </ul>
                        <div className="tab-label mt-4">Contenido</div>
                    </div>

                    {/* Columna Derecha */}
                    <div className="col-md-6 bg-light-green p-5 rounded-end position-relative" data-aos="fade-left" data-aos-delay="200">

                        <div className='d-flex justify-content-center'>
                            <div className='position-relative z-0'>
                                <h3 className="subtitle-rate-card fw-bold text-center">Características</h3>

                                <div className='position-absolute top-100 start-50 translate-middle'>
                                    <svg width="2em" height="2em" viewBox="0 0 16 16" class="position-absolute top-100 start-50 translate-middle bi bi-caret-down-fill" fill="#056059" xmlns="http://www.w3.org/2000/svg"><path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" /></svg>
                                </div>
                            </div>
                        </div>
                        <div className='reach mt-3 rounded p-3'>
                            <h4>Alcance:</h4>
                            <p className="">
                                Un nuevo artículo de contenido en BeHealth recibe 1.000 visitas (en promedio) durante el 1er mes.
                            </p>

                            <h4>Permanencia:</h4>
                            <p className="">
                                El artículo permanecerá publicado de forma indefinida en BeHealth, asegurando visibilidad continua
                                y un posicionamiento orgánico sostenible en buscadores.
                            </p>
                        </div>
                        <div className="includes-box">
                            <div className='shadow-lg rounded p-4 mt-3'>
                                <h5 className="fw-bold text-teal">Incluye:</h5>
                                <ul className="ps-3 mt-2">
                                    <li>Réplica orgánica en RRSS con @mención.</li>
                                    <li>Link desde el Home garantizado  x 1 día.</li>
                                    <li>Segmentado a Categorías internas.</li>
                                </ul>
                            </div>
                        </div>

                        <div className='w-100 d-flex justify-content-center'>
                            <div className="investment-box bg-teal text-white p-3 mt-4 rounded shadow-lg">
                                <strong>Inversión Publinota:</strong><br />
                                A cotizar x artículo publicado de por vida.
                            </div>
                        </div>
                        <div className='w-100 d-flex justify-content-center'>
                            <div className='investment-box-2 mt-1'>
                                <strong>*Opción Publinota con Video:</strong><br />
                                A cotizar x artículo c/video publicado de por vida.
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default PubliNotes;
